import { ButtonUnstyled, IconAtom, ToastAtom } from "../../atoms";
import { ToastType } from "../../interfaces/Toast";
import styles from "./styles.module.scss";

interface Props {
  message: string;
  type: ToastType;
  onClose?: () => void;
}

export function ToastMolecule(props: Readonly<Props>) {
  return (
    <ToastAtom type={props.type}>
      <div className={styles.right}>
        <ButtonUnstyled onClick={() => (props.onClose ? props.onClose() : {})} id={"close"}>
          <IconAtom icon={"icon-close-hover"} size={"medium"} alt={"close"} />
        </ButtonUnstyled>
      </div>

      <div className={styles.toast}>
        <p>{props.message}</p>
      </div>
    </ToastAtom>
  );
}
